import { Card, TextField, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";

export default function Login() {
  return (
    <Box display="flex" justifyContent="center" mt={10}>
      <Card sx={{ p: 4, width: 400 }}>
        <Typography variant="h4" textAlign="center">
          Welcome Back
        </Typography>

        <TextField fullWidth label="Mobile Number" margin="normal" />
        <TextField
          fullWidth
          label="Password"
          type="password"
          margin="normal"
        />

        <Button fullWidth variant="contained" sx={{ mt: 2 }}>
          Login
        </Button>

        <Typography mt={2} textAlign="center">
          Don’t have an account? <Link to="/auth/register">Register</Link>
        </Typography>
      </Card>
    </Box>
  );
}
